module.exports = __webpack_public_path__ + "img/truck-solid.f36012c2.svg";